module.exports = __webpack_public_path__ + "img/3.c3742cc6.webp";